export enum UserTypeEnum {
    APP_USER,
    BROTHER_EMPLOYEE
}
